<div *ngIf="!newInref && !editInref ">
  <h1 style="
font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
  Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
font-weight: 500;
color: #105481;
margin-bottom: 0.5rem;
font-size: 2.5rem;
font-weight: 500;
line-height: 1.2;
" id="inrefHeader">
    Fordelingsregler for fordelingskomponenten
  </h1>

  <h3 *ngIf="isUsersystemEmpty" class="messageSpace">{{userSystemMessage}}</h3>

  <div class="left" style="padding-bottom: 20px;" *ngIf="isEnable()">
    <button pButton (click)="onNyInref()" id="newInrefbutton">
      <mat-icon>add</mat-icon>Tilføj fordelingsregel</button>
  </div>

  <div>
    <p-table #dt [value]="administration" [rows]="rowsPerPage" [paginator]="false" id="inRefTable"
      (onRowSelect)="onRowSelect($event)" stateStorage="session" [sortField]="sortField" [sortOrder]="sortOrder"
      [stateKey]="tableName" sortMode="single" [rowHover]="true" dataKey="id" selectionMode="single"
      [showFirstLastIcon]="false" [customSort]="true" (sortFunction)="customSort($event)">
      <ng-template pTemplate="header">
        <tr style="width: 100%;">
          <th hidden="true" style="width: 0%;" id="adminId">id</th>
          <th style="width: 35%" pSortableColumn="title" id="titleHead">
            Titel<p-sortIcon field="title"></p-sortIcon>
          </th>
          <th style="width: 10%" pSortableColumn="kleEmne" id="emneHead">
            Emne<p-sortIcon field="kleEmne"></p-sortIcon>
          </th>
          <th style="width: 13%;" pSortableColumn="handlingFacet" id="HandlingsfacetHead">
            Handlingsfacet<p-sortIcon field="handlingFacet"></p-sortIcon>
          </th>
          <th style="width: 18%" pSortableColumn="systemName" id="SystemnavnHead">
            Systemnavn<p-sortIcon field="systemName"></p-sortIcon>
          </th>
          <th style="width: 12%" pSortableColumn="validFrom" id="validFromhead">
            Gyldig fra<p-sortIcon field="validFrom"></p-sortIcon>
          </th>
          <th style="width: 12%" pSortableColumn="validTo" id="validTohead">
            Gyldig til<p-sortIcon field="validTo"></p-sortIcon>
          </th>
        </tr>
        <tr>
          <th id="nameFilterHead">
            <input style="width: 100%" pInputText type="text" #textInput1 id="nameFilter"
              (input)="inputChange(textInput1.value, 'title')"
              [value]="$any(dt.filters['title'])?.value" class="p-column-filter" />
          </th>
          <th id="serviceTypeFilterHead">
            <input style="width: 100%" pInputText type="text" #textInput2 id="serviceTypeFilter"
              (input)="inputChange(textInput2.value, 'kleEmne')"
              [value]="$any(dt.filters['kleEmne'])?.value" class="p-column-filter" />
          </th>
          <th id="routeTypeFilterHead">
            <input style="width: 100%" pInputText type="text" #textInput3 id="routeTypeFilter"
              (input)="inputChange(textInput3.value, 'handlingFacet')"
              [value]="$any(dt.filters['handlingFacet'])?.value" class="p-column-filter" />
          </th>
          <th id="flagFilterHead">
            <input style="width: 100%" pInputText type="text" #textInput4 id="flagFilter"
              (input)="inputChange(textInput4.value, 'systemName')"
              [value]="$any(dt.filters['systemName'])?.value" class="p-column-filter" />
          </th>
          <th id="flagFilterHead">
            <input style="width: 100%" pInputText type="text" #textInput5  id="flagFilter"
              (input)="inputChange(textInput5.value, 'validFromSort')" 
              [value]="$any(dt.filters['validFromSort'])?.value" class="p-column-filter"/>
          </th>
          <th id="flagFilterHead">
            <input style="width: 100%" pInputText type="text" #textInput6 id="flagFilter"
              (input)="inputChange(textInput6.value, 'validToSort')"
              [value]="$any(dt.filters['validToSort'])?.value" class="p-column-filter" />
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-prod>
        <tr [pSelectableRow]="prod">
          <td hidden="true" id="{{prod.infRefId}}">{{ prod?.infRefId }}</td>
          <td id="{{prod.title}}">
            <span [pTooltip]="prod?.title" id="prod.title">
            {{ prod?.title }}</span></td>
          <td id="{{prod.kleEmne}}">
            <span [pTooltip]="prod?.kleEmne" id="prod.kleEmne">
            {{ prod?.kleEmne }}</span></td>
          <td id="{{prod.handlingFacet}}">
            <span [pTooltip]="prod?.handlingFacet" id="prod.handlingFacet">
              {{ prod?.handlingFacet }}</span></td>
          <td id="{{prod.systemName}}">
            <span [pTooltip]="prod?.systemName" id="prod.systemName">
              {{ prod?.systemName }}</span></td>
          <td id="{{prod?.validFrom}}">
            <span pTooltip="{{formatDate(prod?.validFrom)}}" id="prod.validFrom">
              {{ formatDate(prod?.validFrom)}}</span></td>
          <td id="{{prod?.validTo}}">
            <span pTooltip="{{formatDate(prod?.validTo)}}" id="prod.validTo">
              {{ formatDate(prod?.validTo)}}</span></td>
        </tr>

      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6" style="text-align: center;">
              <div class="d-flex justify-content-center" *ngIf="isLoading">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden"></span>
                </div>
              </div>
              <span  *ngIf="!isLoading">Ingen Fordelingsregler fundet</span>
            </td>
        </tr>
    </ng-template>
    </p-table>
    <ngb-pagination #paginationRoute *ngIf="showPagination" aria-label="pagination"
      class="d-flex justify-content-center" [collectionSize]="totalRecords" [(page)]="currentPage" [pageSize]="rowsPerPage"
      [maxSize]="5" [rotate]="true" size="lg" [boundaryLinks]="false" (pageChange)="onPageChange($event)">
    </ngb-pagination>

    <br />
  </div>
</div>

<app-edit-route (cancelClickEvent)="editCancel()" 
  (submitClickedEvent)="editSubmit()" [newInref]="newInref" *ngIf="newInref || editInref"
  [infRef]="infRef" [administration]="administration" [validFromDateMap]="validFromDateMap" [validToDateMap]="validToDateMap" [changedDate]="changedDate"></app-edit-route>


<p-confirmDialog [ngStyle]="{ backgroundColor: '$dialogHeaderBg: #ffffff;' }"
  [transitionOptions]="'400ms cubic-bezier(0.25, 0.8, 0.25, 1)'" header="Confirmation" acceptIcon="" rejectIcon="">
</p-confirmDialog>

